import * as React from "react";
import styles from "./Header.module.scss";

const Header = (props: { fadeout?: boolean, children: React.ReactElement }) => {
  return <div className={props.fadeout ? styles.fadeoutHeader : styles.header}>{props.children}</div>;
};

export default Header;
